import { BarChart3, TrendingUp, Users, AlertTriangle } from "lucide-react";
import { UnifiedRecord, SystemMetrics } from "../../../types";
import { StaffAvailability } from "../../Dashboard/StaffAvailability";

interface DashboardProps {
  records: UnifiedRecord[];
  metrics: SystemMetrics | null;
  loading: boolean;
}

export function ManagementDashboard({ metrics, loading }: DashboardProps) {
  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center gap-3 mb-6 border-b border-white/10 pb-4">
        <BarChart3 className="w-8 h-8 text-indigo-400" />
        <div>
          <h2 className="text-xl font-semibold text-white">Management Executive View</h2>
          <p className="text-gray-400 text-sm">High-level hospital performance KPIs</p>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="rounded-2xl border border-white/8 bg-gradient-to-br from-indigo-500/10 to-indigo-500/5 p-6">
          <div className="flex items-center gap-2 text-indigo-400 mb-2">
            <TrendingUp className="w-5 h-5" />
            <h3 className="font-semibold">Hospital Occupancy</h3>
          </div>
          <div className="text-4xl font-bold text-white mb-1">
            {loading ? "..." : `${metrics?.occupancy_rate_pct ?? 0}%`}
          </div>
          <p className="text-gray-400 text-sm">
            {metrics?.occupied_beds ?? 0} of {metrics?.total_beds ?? 0} beds in use
          </p>
        </div>
        
        <div className="rounded-2xl border border-white/8 bg-gradient-to-br from-teal-500/10 to-teal-500/5 p-6">
          <div className="flex items-center gap-2 text-teal-400 mb-2">
            <Users className="w-5 h-5" />
            <h3 className="font-semibold">Patient Flow</h3>
          </div>
          <div className="flex justify-between items-end">
            <div>
              <div className="text-3xl font-bold text-white">124</div>
              <p className="text-gray-400 text-sm">Admissions Today</p>
            </div>
            <div className="text-right">
              <div className="text-3xl font-bold text-white">89</div>
              <p className="text-gray-400 text-sm">Discharges Today</p>
            </div>
          </div>
        </div>

        <div className="rounded-2xl border border-white/8 bg-gradient-to-br from-red-500/10 to-red-500/5 p-6">
          <div className="flex items-center gap-2 text-red-400 mb-2">
            <AlertTriangle className="w-5 h-5" />
            <h3 className="font-semibold">Critical Bottlenecks</h3>
          </div>
          <div className="text-4xl font-bold text-white mb-1">
            {loading ? "..." : (metrics?.total_conflicts ?? 0)}
          </div>
          <p className="text-gray-400 text-sm">Active system data conflicts</p>
        </div>
      </div>
      
      {/* Staff Availability Tracker */}
      <StaffAvailability />

      {/* Spacer for future reports */}
      <div className="rounded-2xl border border-white/8 bg-white/5 p-8 text-center mt-6">
        <p className="text-gray-500">End of Month Executive Report Generation is scheduled for the 1st of next month.</p>
      </div>
    </div>
  );
}
